import React, { useState, useEffect } from "react";
import {
  MapContainer as LeafletMap,
  TileLayer,
  CircleMarker,
  Popup,
} from "react-leaflet";
import { Card } from "react-bootstrap";
import axios from "axios";
import { fetchAnalyticsData } from "../dataService";
import { FaUser, FaCircle } from "react-icons/fa";

const GOOGLE_API_KEY = "AIzaSyD16h98hJe26HkkEvzKPbH2WytgT5srggM";

const MapComponent = () => {
  const [citiesData, setCitiesData] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState(0);

  const getCoordinatesCached = async (city, country) => {
    const cache = JSON.parse(localStorage.getItem("geocodeCache") || "{}");
    const key = `${city}-${country}`;
    if (cache[key]) return cache[key];

    try {
      const response = await axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json",
        {
          params: {
            address: `${city}, ${country}`,
            key: GOOGLE_API_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        const coords = response.data.results[0].geometry.location;
        cache[key] = coords;
        localStorage.setItem("geocodeCache", JSON.stringify(cache));
        return coords;
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  useEffect(() => {
    const loadData = async () => {
      const analytics = await fetchAnalyticsData();
      const tpData = analytics?.AR?.mappa;
      if (!tpData) return;

      const combined = [
        ...tpData.ecommerce.map((c) => ({ ...c, tipo: "Ecommerce" })),
        ...tpData.istituzionale.map((c) => ({
          ...c,
          tipo: "Istituzionale",
        })),
      ];

      const coordsArr = [];
      let total = 0;

      for (const city of combined) {
        if (!city.descrizioneCity) continue;

        const coords = await getCoordinatesCached(
          city.descrizioneCity,
          city.descrizioneCountry
        );

        if (coords) {
          const active = Number(city.activeUser) || 0;
          total += active;

          coordsArr.push({
            name: city.descrizioneCity,
            position: coords,
            visits: active,
            tipo: city.tipo,
          });
        }
      }

      setCitiesData(coordsArr);
      setOnlineUsers(total);
    };

    loadData();
    const interval = setInterval(loadData, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Card
      style={{
        borderRadius: "10px",
        position: "relative",
        overflow: "hidden",
      }}
      className="card"
    >
      {/* CONTENITORE MAPPA */}
      <div style={{ height: "100%", width: "100%", position: "relative" }}>
        
        {/* HEADER SEMPRE VISIBILE */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 9999,
            background: "rgba(255,255,255,0.95)",
            padding: "8px 12px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <FaCircle
            style={{
              color: "#28a745",
              fontSize: "8px",
              marginRight: "6px",
              animation: "pulse 1.5s infinite",
            }}
          />
          <FaUser
            style={{ fontSize: "12px", marginRight: "6px", color: "#666" }}
          />
          <span style={{ fontSize: "0.75rem", fontWeight: "800" }}>
            UTENTI ONLINE:{" "}
            <span style={{ color: "rgba(241,111,36,1)" }}>{onlineUsers}</span>
          </span>
        </div>

        {/* MAPPA */}
        <LeafletMap
          style={{ height: "100%", width: "100%" }}
          center={[41.8719, 12.5674]}
          zoom={5}
          zoomControl={false}
          attributionControl={false}
        >
          <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />

          {citiesData.map((city, index) => (
            <CircleMarker
              key={index}
              center={[city.position.lat, city.position.lng]}
              radius={Math.max(6, Math.sqrt(city.visits) * 2.5)}
              pathOptions={{
                color: "white",
                weight: 1,
                fillColor:
                  city.tipo === "Ecommerce" ? "rgba(241,111,36,1)" : "#444",
                fillOpacity: 0.8,
              }}
            >
              <Popup>
                <strong>{city.name}</strong>
                <br />
                {city.tipo}: {city.visits}
              </Popup>
            </CircleMarker>
          ))}
        </LeafletMap>
      </div>

      {/* ANIMAZIONE */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </Card>
  );
};

export default MapComponent;